import { SpreaderLegInput } from '@/features/spreader/types'
import { SpreaderAlgoParams, SpreaderLeg } from '@/types/generated/algo'
import { Exchange, TradeVenue } from '@/types/generated/common/types'

// Per the Spreader integration guide §3.1, `SpreaderLeg.exchange` / `.tradeVenue` and
// `SpreaderAlgoParams.tradeVenue` are server-stamped — a client-supplied venue is never
// trusted, so every venue field here is left UNSPECIFIED.
export function buildSpreaderParams(
  legs: SpreaderLegInput[],
  slicePct: string,
  limitPrice: string
): SpreaderAlgoParams {
  const spreaderLegs: SpreaderLeg[] = legs.map((leg) => ({
    symbol: leg.symbol,
    quantity: leg.quantity,
    denomination: leg.denomination,
    accountId: leg.accountId,
    exchange: Exchange.EXCHANGE_UNSPECIFIED,
    tradeVenue: TradeVenue.TRADE_VENUE_UNSPECIFIED,
    reduceOnly: leg.reduceOnly,
    role: leg.role,
    side: leg.side,
  }))

  const params: SpreaderAlgoParams = {
    legs: spreaderLegs,
    slicePct: slicePct.trim(),
    tradeVenue: TradeVenue.TRADE_VENUE_UNSPECIFIED,
  }
  if (limitPrice.trim() !== '') {
    params.limitPrice = limitPrice.trim()
  }
  return params
}
